<!-- @format -->

<template>
    <div>
        <h5 class="gst-event-not-available__title">
            {{ $t('title') }}
        </h5>
        <div class="gst-event-not-available__content">
            {{ $t('subtitle') }}
            <a :href="homeUrl">{{ $t('homePage') }}</a>
        </div>
    </div>
</template>

<script>
import tenantUrlsConstants from '@tenant/app/utils/constants/tenantUrls';

export default {
    name: 'EventNonTransactableWarning',
    i18nOptions: {
        namespaces: '_common',
        keyPrefix: 'messages.eventState.nonTransactable',
    },
    data() {
        return {
            homeUrl: tenantUrlsConstants.home,
        };
    },
};
</script>
